import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import t from "module/translations";
import useDateFormat from "toolkit/useDateFormat";
import StaffNameText from "module/staff/StaffNameText";
import LinkWithIcon from "component/link/LinkWithIcon";
import { CertificationInterface } from "module/certification/types";
import { getPathToCertificationToBeSignedDetails } from "module/certification/helper/getPath";

interface Props {
  certification: CertificationInterface;
}

const ToBeSignedListTableRowCertification: React.FC<Props> = ({
  certification,
}) => {
  const { formatDateTime } = useDateFormat();

  return (
    <TableRow
      {...{
        hover: true,
        tabIndex: -1,
        key: certification.id,
      }}
    >
      <TableCell>{t.competencyManagement.certificationText}</TableCell>
      <TableCell>
        <LinkWithIcon
          {...{
            label: certification.name,
            path: getPathToCertificationToBeSignedDetails(certification.id),
          }}
        />
        {certification.assigneeId && (
          <StaffNameText {...{ staffId: certification.assigneeId }} />
        )}
      </TableCell>
      <TableCell>
        {t.competencyManagement.certification.type.initialText}
      </TableCell>
      <TableCell>{formatDateTime(certification.scheduledStartDate)}</TableCell>
    </TableRow>
  );
};

export default React.memo(ToBeSignedListTableRowCertification);
